import * as i0 from "@angular/core";
var GenericUtils = /** @class */ (function () {
    function GenericUtils() {
    }
    GenericUtils.prototype.isPath = function (path, pathToCheck) {
        return path.includes(pathToCheck);
    };
    GenericUtils.prototype.b64toBlob = function (base64) {
        var byteString = atob(base64.split(",")[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([
            ab
        ], { type: "image/png" });
    };
    GenericUtils.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GenericUtils_Factory() { return new GenericUtils(); }, token: GenericUtils, providedIn: "root" });
    return GenericUtils;
}());
export { GenericUtils };
